import React from "react";
import * as R from 'ramda';
import {compose} from 'recompose';
import {connect} from 'react-redux';
import {
    ArrayInput,
    SimpleFormIterator,
    List,
    Datagrid,
    TextField,
    FunctionField,
    ReferenceField,
    DateField,
    BooleanField,
    Show,
    SimpleShowLayout,
    EmailField,
    Edit,
    TabbedForm,
    FormTab,
    DisabledInput,
    TextInput,
    BooleanInput,
    required,
    minLength,
    CardActions,
    DeleteButton,
    Toolbar,
    SimpleForm,
    Create,
} from 'react-admin';
import TableCell from "@material-ui/core/TableCell";
import {TableFormIterator} from './TableFormIterator';
import {UserEmailField} from '../../misc/customFields';
import {getUserId} from '../../redux/user/selectors';


export const StaffList = props => {
    return (
        <div>
            <List {...props} title="Staff" >
                <Datagrid>
                    <ReferenceField
                        label="User"
                        source="id"
                        reference="staff"
                        >
                        <UserEmailField />
                    </ReferenceField>
                    <FunctionField
                        label="Full Name"
                        render={record =>
                        `${record.first_name} ${record.last_name}`}/>
                    <DateField source="last_login" showTime label="Last Login" />
                    <BooleanField source="is_active"/>
                    <BooleanField source="is_superuser"/>
                    <DateField source="created" showTime label="Created" />
                    <DateField source="updated" showTime label="Updated" />
                </Datagrid>
            </List>
        </div>
    );
};

const editStyles = {
    root: {alignItems: 'flex-start'},
}


const mapStateToProps = state => ({
    superUserId: getUserId(state),
    currentUserId: R.pathOr(0, ['form', 'record-form', 'values', 'id'], state),
});

const PermissionRows = (props) => {
    let entity = R.pathOr(null, ['record', 'entity'], props);
    const perm = R.pathOr("-", ['record', 'perm'], props);
    const {source} = props;
    if (!entity || !source){
        return null;
    }

    if (entity === 'doctors') {
        entity = 'clinicians';
    }

    return (
        <>
            <TableCell>{entity}</TableCell>
            <TableCell>{perm}</TableCell>
            <TableCell style={{ width: '35%' }}>
                <BooleanInput
                    source={`${source}.status`}
                    resource="staff"
                    label="status"
                />
            </TableCell>
        </>
    )
}


const StaffShow_ = props => {
    const {currentUserId, superUserId} = props;
    return (
        <Edit {...props}>
            <SimpleForm>
                    <DisabledInput source="id"/>
                    <DisabledInput source="created" showTime label="Created" />
                    <TextInput source="email" type="email" />
                    <TextInput source="first_name"/>
                    <TextInput source="last_name"/>
                    {currentUserId !== superUserId && <BooleanInput source="is_active"/>}
                    <TextInput source="password" type="password" validate={minLength(8)}/>
                    <ArrayInput source="permissions">
                        <TableFormIterator disableAdd disableRemove>
                            <PermissionRows/>
                        </TableFormIterator>
                    </ArrayInput>
            </SimpleForm>
        </Edit>
    )
}

const enhace = compose(
    connect(mapStateToProps)
);

export const StaffShow = enhace(StaffShow_);


const defaultValues = {
  permissions: [
    {
      entity: 'patients',
      perms: [
        {
          perm: 'view cpi data',
          status: false
        },
        {
          perm: 'view',
          status: false
        }
      ]
    },
    {
      entity: 'doctors',
      perms: [
        {
          perm: 'view',
          status: true
        }
      ]
    }
  ]
};


const defaultValues1 = {
    permissions: [
        {
          perm: 'view cpi data',
          status: false,
          entity: 'patients'
        },
        {
          perm: 'view',
          status: false,
          entity: 'patients'
        },
        {
          perm: 'view',
          status: false,
          entity: 'doctors'
        }
  ]
}


export const StaffCreate = props => {
    return (
        <Create {...props}>
            <SimpleForm redirect="list" defaultValue={defaultValues1}>
                <TextInput source="email" type="email" validate={required()}/>
                <TextInput source="first_name" validate={required()}/>
                <TextInput source="last_name" validate={required()}/>
                <BooleanInput source="is_active"/>
                <TextInput source="password" type="password" validate={[minLength(8),required()]}/>
                <ArrayInput source="permissions">
                    <TableFormIterator disableAdd disableRemove defaultValues={defaultValues1}>
                        <PermissionRows/>
                    </TableFormIterator>
                </ArrayInput>
            </SimpleForm>
        </Create>
    )
}
